/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * てのひら眼科 Patient API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation
} from '@tanstack/react-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query'
import {
  useCallback
} from 'react'
import type {
  BadRequestResponse,
  ForbiddenResponse,
  InternalServerErrorResponse,
  PatchUpneeqEyeImagesBodies,
  UnauthorizedResponse,
  UnprocessableContentResponse
} from '.././model'
import { useAPIPatientClient } from '../../apiPatientConfig';
import type { ErrorType, BodyType } from '../../apiPatientConfig';



/**
 * アップニーク診療の右目・左目・両目の写真をアップロードする。
 * @summary アップニーク目の写真のアップロード
 */
export const usePatchUpneeqEyeImagesHook = () => {
        const patchUpneeqEyeImages = useAPIPatientClient<void>();

        return useCallback((
    consultationId: string,
    patchUpneeqEyeImagesBodies: BodyType<PatchUpneeqEyeImagesBodies>,
 ) => {
        return patchUpneeqEyeImages(
          {url: `/patient/api/consultations/${consultationId}/upneeq-eye-images`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchUpneeqEyeImagesBodies
    },
          );
        }, [patchUpneeqEyeImages])
      }
    


export const usePatchUpneeqEyeImagesMutationOptions = <TError = ErrorType<BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableContentResponse | InternalServerErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePatchUpneeqEyeImagesHook>>>, TError,{consultationId: string;data: BodyType<PatchUpneeqEyeImagesBodies>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePatchUpneeqEyeImagesHook>>>, TError,{consultationId: string;data: BodyType<PatchUpneeqEyeImagesBodies>}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      const patchUpneeqEyeImages =  usePatchUpneeqEyeImagesHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePatchUpneeqEyeImagesHook>>>, {consultationId: string;data: BodyType<PatchUpneeqEyeImagesBodies>}> = (props) => {
          const {consultationId,data} = props ?? {};

          return  patchUpneeqEyeImages(consultationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchUpneeqEyeImagesMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePatchUpneeqEyeImagesHook>>>>
    export type PatchUpneeqEyeImagesMutationBody = BodyType<PatchUpneeqEyeImagesBodies>
    export type PatchUpneeqEyeImagesMutationError = ErrorType<BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableContentResponse | InternalServerErrorResponse>

    /**
 * @summary アップニーク目の写真のアップロード
 */
export const usePatchUpneeqEyeImages = <TError = ErrorType<BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableContentResponse | InternalServerErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePatchUpneeqEyeImagesHook>>>, TError,{consultationId: string;data: BodyType<PatchUpneeqEyeImagesBodies>}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePatchUpneeqEyeImagesHook>>>,
        TError,
        {consultationId: string;data: BodyType<PatchUpneeqEyeImagesBodies>},
        TContext
      > => {

      const mutationOptions = usePatchUpneeqEyeImagesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    